import Axios from 'axios'
import { Dispatch } from 'redux'

import { ActionResponse, Id } from 'util/types/index'
import { Document, DocumentData, DocumentTypes } from './types'
import { clearAlert, createAlert, handleError } from 'util/modules/Alert/redux/actions'

export function createDocument (personId: Id, data: DocumentData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Document>> => {
    return Axios
      .post(`/person/${personId}/document`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: DocumentTypes.DOCUMENT_CREATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao cadastrar o documento')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function updateDocument (personId: Id, id: Id, data: DocumentData) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Document>> => {
    return Axios
      .put(`/person/${personId}/document/${id}`, data)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: DocumentTypes.DOCUMENT_UPDATE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao atualizar o documento')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function deleteDocument (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Document>> => {
    return Axios
      .delete(`/person/${personId}/document/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res?.data) {
          dispatch({ type: DocumentTypes.DOCUMENT_DELETE, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao remover o documento')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getDocument (personId: Id, id: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Document>> => {
    return Axios
      .get(`/person/${personId}/document/${id}`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: DocumentTypes.DOCUMENT_GET, payload: res.data })
        }
        return res
      })
      .catch((error) => {
        return handleError(error, 'Ocorreu um erro ao buscar o documento')
      })
      .then(async res => {
        if (res?.status !== 'success') {
          createAlert(res)(dispatch)
          await clearAlert(1500)(dispatch)
        }

        return res
      })
  }
}

export function getDocumentList (personId: Id) {
  return async (dispatch: Dispatch): Promise<ActionResponse<Document[]>> => {
    return Axios
      .get(`/person/${personId}/document`)
      .then(res => res.data)
      .then(res => {
        if (res?.status === 'success' && res.data) {
          dispatch({ type: DocumentTypes.DOCUMENT_GET_LIST, payload: res.data })
        }
        return res
      })
  }
}
